import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f4f5f9] px-4">
      <div className="flex flex-col items-center text-center max-w-md">
        {/* 404 number */}
        <div
          className="font-extrabold leading-none select-none"
          style={{
            fontSize: "clamp(120px, 22vw, 180px)",
            background: "linear-gradient(135deg, #5b648f 0%, #8b92b3 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          404
        </div>

        {/* Divider line */}
        <div
          className="rounded-full mb-6"
          style={{
            width: 60,
            height: 4,
            background: "linear-gradient(90deg, #5b648f, #8b92b3)",
          }}
        />

        {/* Heading */}
        <h2 className="text-[22px] font-semibold text-gray-800 mb-2">
          Page Not Found
        </h2>

        {/* Description */}
        <p className="text-[15px] text-gray-500 mb-8 leading-relaxed">
          The page you're looking for doesn't exist or has been moved.
        </p>

        {/* Back to home button */}
        <Button
          variant="contained"
          onClick={() => navigate("/")}
          sx={{
            backgroundColor: "#5b648f",
            borderRadius: "12px",
            padding: "10px 32px",
            fontSize: "15px",
            fontWeight: 500,
            textTransform: "none",
            letterSpacing: "0.3px",
            boxShadow: "0 4px 14px rgba(91, 100, 143, 0.35)",
            "&:hover": {
              backgroundColor: "#4a5278",
              boxShadow: "0 6px 20px rgba(91, 100, 143, 0.45)",
            },
          }}
        >
          Back to Home
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
